/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderPublish
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderPublish {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderPublish
     */
    payment_id?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderPublishFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderPublish {
    return DigitizingserviceMelcoDigitizingModelsOrderPublishFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderPublishFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderPublish {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payment_id': !exists(json, 'payment_id') ? undefined : json['payment_id'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderPublishToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderPublish | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payment_id': value.payment_id,
    };
}


